(function recentElementsDefinition() {
    'use strict';
    angular.module('Entities')
        .service('recentElementsService', [
            'restUrlBuilder', function recentElementsService(restUrlBuilder) {

                this.getRecentDocuments = function getRecentDocuments() {
                    var params = { Type: "DOCUMENTS" };

                    return restUrlBuilder.all('RecentElements')
                        .get({ params: params });
                };

                this.getRecentFolders = function getRecentFolders() {
                    var params = { Type: "CONTAINERS" };

                    return restUrlBuilder.all('RecentElements')
                        .get({ params: params });
                };

                this.getRecentElements = function getRecentElements(name) {
                    var params = { Type: name };

                    return restUrlBuilder.all('RecentElements').get({ params: params });
                };
            }
        ]);
})();